<template>
  <HeroSection />
  <ExploreSection />
  <SpeakersSection />
  <ProgramSection />
  <br />
</template>

<script>
import HeroSection from "@/components/conference/HeroSection.vue";
import ExploreSection from "@/components/conference/ExploreSection.vue";
import SpeakersSection from "@/components/conference/SpeakersSection.vue";
import ProgramSection from "@/components/conference/ProgramSection.vue";
import { PATHS } from "@/data/nav";

export default {
  name: "HomeView",
  components: {
    HeroSection,
    ExploreSection,
    SpeakersSection,
    ProgramSection,
  },
  data() {
    return {
      PATHS,
    };
  },
};
</script>
